/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AlertApi extends runtime.BaseAPI {
    /**
     * Create a new alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Creates the subscription in Alert Tool 3. Returns the subscription with its ID  Args:     request: Subscription creation payload (locations, triggers).  Returns:     Created subscription with ID.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 500: Alert Tool unavailable.
     * Create Subscription
     */
    async v2CreateAlertSubscriptionRaw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionCreateRequest'] == null) {
            throw new runtime.RequiredError('subscriptionCreateRequest', 'Required parameter "subscriptionCreateRequest" was null or undefined when calling v2CreateAlertSubscription().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscription`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['subscriptionCreateRequest'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Creates the subscription in Alert Tool 3. Returns the subscription with its ID  Args:     request: Subscription creation payload (locations, triggers).  Returns:     Created subscription with ID.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 500: Alert Tool unavailable.
     * Create Subscription
     */
    async v2CreateAlertSubscription(requestParameters, initOverrides) {
        const response = await this.v2CreateAlertSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Creates the subscription in Alert Tool 3. Returns the subscription with its ID  Args:     request: Subscription creation payload (locations, triggers).  Returns:     Created subscription with ID.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 500: Alert Tool unavailable.
     * Create Subscription
     */
    async v2CreateAlertSubscription_1Raw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionCreateRequest'] == null) {
            throw new runtime.RequiredError('subscriptionCreateRequest', 'Required parameter "subscriptionCreateRequest" was null or undefined when calling v2CreateAlertSubscription_1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscription`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['subscriptionCreateRequest'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Creates the subscription in Alert Tool 3. Returns the subscription with its ID  Args:     request: Subscription creation payload (locations, triggers).  Returns:     Created subscription with ID.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 500: Alert Tool unavailable.
     * Create Subscription
     */
    async v2CreateAlertSubscription_1(requestParameters, initOverrides) {
        const response = await this.v2CreateAlertSubscription_1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Deletes the subscription from Alert Tool 3. Returns success confirmation  Args:     subscription_id: The subscription ID to delete.  Returns:     Confirmation with message.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Delete Subscription
     */
    async v2DeleteAlertSubscriptionRaw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2DeleteAlertSubscription().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions/{subscription_id}`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete an alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Deletes the subscription from Alert Tool 3. Returns success confirmation  Args:     subscription_id: The subscription ID to delete.  Returns:     Confirmation with message.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Delete Subscription
     */
    async v2DeleteAlertSubscription(requestParameters, initOverrides) {
        const response = await this.v2DeleteAlertSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Deletes the subscription from Alert Tool 3. Returns success confirmation  Args:     subscription_id: The subscription ID to delete.  Returns:     Confirmation with message.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Delete Subscription
     */
    async v2DeleteAlertSubscription_2Raw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2DeleteAlertSubscription_2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions/{subscription_id}`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete an alert subscription.  This endpoint: 1. Validates the user is authenticated 2. Deletes the subscription from Alert Tool 3. Returns success confirmation  Args:     subscription_id: The subscription ID to delete.  Returns:     Confirmation with message.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Delete Subscription
     */
    async v2DeleteAlertSubscription_2(requestParameters, initOverrides) {
        const response = await this.v2DeleteAlertSubscription_2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Notification Destination
     */
    async v2GetAlertNotificationDestinationRaw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2GetAlertNotificationDestination().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profile_id'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/{subscription_id}/destination`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Notification Destination
     */
    async v2GetAlertNotificationDestination(requestParameters, initOverrides) {
        const response = await this.v2GetAlertNotificationDestinationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Notification Destination
     */
    async v2GetAlertNotificationDestination_3Raw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2GetAlertNotificationDestination_3().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profile_id'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/{subscription_id}/destination`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Notification Destination
     */
    async v2GetAlertNotificationDestination_3(requestParameters, initOverrides) {
        const response = await this.v2GetAlertNotificationDestination_3Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Notifications
     */
    async v2GetAlertNotificationsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Notifications
     */
    async v2GetAlertNotifications(requestParameters = {}, initOverrides) {
        const response = await this.v2GetAlertNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Notifications
     */
    async v2GetAlertNotifications_4Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Notifications
     */
    async v2GetAlertNotifications_4(requestParameters = {}, initOverrides) {
        const response = await this.v2GetAlertNotifications_4Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific alert subscription.  Args:     subscription_id: The subscription ID to retrieve.  Returns:     Subscription details.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Get Subscription
     */
    async v2GetAlertSubscriptionRaw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2GetAlertSubscription().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions/{subscription_id}`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific alert subscription.  Args:     subscription_id: The subscription ID to retrieve.  Returns:     Subscription details.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Get Subscription
     */
    async v2GetAlertSubscription(requestParameters, initOverrides) {
        const response = await this.v2GetAlertSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific alert subscription.  Args:     subscription_id: The subscription ID to retrieve.  Returns:     Subscription details.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Get Subscription
     */
    async v2GetAlertSubscription_5Raw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling v2GetAlertSubscription_5().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions/{subscription_id}`;
        urlPath = urlPath.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific alert subscription.  Args:     subscription_id: The subscription ID to retrieve.  Returns:     Subscription details.  Raises:     HTTPException 403: User is not provisioned.     HTTPException 404: Subscription not found.     HTTPException 500: Alert Tool unavailable.
     * Get Subscription
     */
    async v2GetAlertSubscription_5(requestParameters, initOverrides) {
        const response = await this.v2GetAlertSubscription_5Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all alert subscriptions for the current user.  This endpoint: 1. Validates the user is authenticated 2. Fetches the user\'s subscriptions from Alert Tool 3. Validates the user exists in Alert Tool  Returns:     Dictionary with subscriptions and user info.  Raises:     HTTPException 403: User is not provisioned in Alert Tool.     HTTPException 500: Alert Tool not configured or unavailable.
     * Get Subscriptions
     */
    async v2GetAlertSubscriptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all alert subscriptions for the current user.  This endpoint: 1. Validates the user is authenticated 2. Fetches the user\'s subscriptions from Alert Tool 3. Validates the user exists in Alert Tool  Returns:     Dictionary with subscriptions and user info.  Raises:     HTTPException 403: User is not provisioned in Alert Tool.     HTTPException 500: Alert Tool not configured or unavailable.
     * Get Subscriptions
     */
    async v2GetAlertSubscriptions(initOverrides) {
        const response = await this.v2GetAlertSubscriptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get all alert subscriptions for the current user.  This endpoint: 1. Validates the user is authenticated 2. Fetches the user\'s subscriptions from Alert Tool 3. Validates the user exists in Alert Tool  Returns:     Dictionary with subscriptions and user info.  Raises:     HTTPException 403: User is not provisioned in Alert Tool.     HTTPException 500: Alert Tool not configured or unavailable.
     * Get Subscriptions
     */
    async v2GetAlertSubscriptions_6Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/subscriptions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all alert subscriptions for the current user.  This endpoint: 1. Validates the user is authenticated 2. Fetches the user\'s subscriptions from Alert Tool 3. Validates the user exists in Alert Tool  Returns:     Dictionary with subscriptions and user info.  Raises:     HTTPException 403: User is not provisioned in Alert Tool.     HTTPException 500: Alert Tool not configured or unavailable.
     * Get Subscriptions
     */
    async v2GetAlertSubscriptions_6(initOverrides) {
        const response = await this.v2GetAlertSubscriptions_6Raw(initOverrides);
        return await response.value();
    }
    /**
     * Mark Notification Read
     */
    async v2MarkAlertNotificationReadRaw(requestParameters, initOverrides) {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError('notificationId', 'Required parameter "notificationId" was null or undefined when calling v2MarkAlertNotificationRead().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/{notification_id}/read`;
        urlPath = urlPath.replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters['notificationId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark Notification Read
     */
    async v2MarkAlertNotificationRead(requestParameters, initOverrides) {
        await this.v2MarkAlertNotificationReadRaw(requestParameters, initOverrides);
    }
    /**
     * Mark Notification Read
     */
    async v2MarkAlertNotificationRead_7Raw(requestParameters, initOverrides) {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError('notificationId', 'Required parameter "notificationId" was null or undefined when calling v2MarkAlertNotificationRead_7().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/{notification_id}/read`;
        urlPath = urlPath.replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters['notificationId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark Notification Read
     */
    async v2MarkAlertNotificationRead_7(requestParameters, initOverrides) {
        await this.v2MarkAlertNotificationRead_7Raw(requestParameters, initOverrides);
    }
    /**
     * Mark All Notifications Read
     */
    async v2MarkAllAlertNotificationsReadRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/read-all`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark All Notifications Read
     */
    async v2MarkAllAlertNotificationsRead(initOverrides) {
        await this.v2MarkAllAlertNotificationsReadRaw(initOverrides);
    }
    /**
     * Mark All Notifications Read
     */
    async v2MarkAllAlertNotificationsRead_8Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/alert/notifications/read-all`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark All Notifications Read
     */
    async v2MarkAllAlertNotificationsRead_8(initOverrides) {
        await this.v2MarkAllAlertNotificationsRead_8Raw(initOverrides);
    }
}
